// Channel + landing resolution.
//
// resolveChannel() and resolveLanding() are lifted verbatim from
// static/attribution.js — that logic was reviewed and signed off,
// so the values we send to the backend stay byte-identical to the static-site
// implementation. Only the landing derivation differs: in the static site it
// strips '.html' from the page filename; in the SPA it derives from the
// pathname instead ('/' → 'home', '/learn/welsh' → 'learn-welsh').

function normaliseChannel(raw) {
  const s = String(raw).toLowerCase().trim();
  if (/^(fb|facebook|meta)$/.test(s)) return 'facebook';
  if (/^(ig|insta|instagram)$/.test(s)) return 'instagram';
  if (/^(tt|tiktok)$/.test(s)) return 'tiktok';
  if (/^(google[_-]?ads|googleads|adwords|gads)$/.test(s)) return 'google_ads';
  if (/^(bing[_-]?ads|bingads|microsoft[_-]?ads)$/.test(s)) return 'bing_ads';
  if (s === 'google') return 'google';
  if (s === 'bing') return 'bing';
  if (s === 'youtube') return 'youtube';
  if (s === 'twitter' || s === 'x') return 'twitter';
  if (s === 'linkedin') return 'linkedin';
  if (s === 'reddit') return 'reddit';
  return s.replace(/[^a-z0-9_-]+/g, '_').slice(0, 40) || 'other';
}

function mapHostToChannel(host) {
  if (/(^|\.)facebook\.com$/.test(host) || host === 'l.facebook.com' || host === 'lm.facebook.com') return 'facebook';
  if (/(^|\.)instagram\.com$/.test(host) || host === 'l.instagram.com') return 'instagram';
  if (/(^|\.)tiktok\.com$/.test(host)) return 'tiktok';
  if (/(^|\.)youtube\.com$/.test(host) || host === 'youtu.be') return 'youtube';
  if (/(^|\.)twitter\.com$/.test(host) || host === 't.co' || /(^|\.)x\.com$/.test(host)) return 'twitter';
  if (/(^|\.)linkedin\.com$/.test(host) || host === 'lnkd.in') return 'linkedin';
  if (/(^|\.)reddit\.com$/.test(host) || host === 'redd.it') return 'reddit';
  if (/(^|\.)pinterest\.[a-z.]+$/.test(host)) return 'pinterest';
  if (/(^|\.)bing\.com$/.test(host)) return 'bing';
  if (/(^|\.)duckduckgo\.com$/.test(host)) return 'duckduckgo';
  if (/(^|\.)google\.[a-z.]+$/.test(host)) return 'google';
  return host.replace(/[^a-z0-9.-]+/g, '_').slice(0, 60) || 'other';
}

export function resolveChannel(search, referrer, currentHostname) {
  const params = new URLSearchParams(search || '');

  const utmSource = params.get('utm_source');
  if (utmSource) return normaliseChannel(utmSource);

  if (params.get('gclid'))   return 'google_ads';
  if (params.get('fbclid'))  return 'facebook';
  if (params.get('ttclid'))  return 'tiktok';
  if (params.get('msclkid')) return 'bing_ads';

  const ref = referrer || '';
  if (!ref) return 'direct';
  let host;
  try { host = new URL(ref).hostname.toLowerCase(); } catch (e) { return 'direct'; }
  if (!host) return 'direct';

  host = host.replace(/^www\./, '');
  if (currentHostname && host === currentHostname.replace(/^www\./, '')) return 'direct';

  return mapHostToChannel(host);
}

// SPA-aware landing slug. Mirrors the static site's slug shape so backend
// values are unchanged:
//   '/'              → 'home'
//   '/pricing'       → 'pricing'
//   '/learn/welsh'   → 'learn-welsh'
//   '/admin/login'   → 'admin-login'
export function resolveLanding(pathname) {
  const path = (pathname || '/').toLowerCase().replace(/\/+$/, '');
  if (!path || path === '') return 'home';
  return path.replace(/^\//, '').replace(/\//g, '-');
}

export function parseAttributionFromUrl(search, referrer, pathname, hostname) {
  return {
    channel: resolveChannel(search, referrer, hostname),
    landing: resolveLanding(pathname),
  };
}
